import React from 'react';
import { Box, Typography } from '@mui/material';
import { useCV } from '../contexts/CVContext';
import CVCompletionGaugeCard from '../../../CVRepository/components/CVCompletionGaugeCard';
import { formatCVForCompletion } from '../../../../utils/cvUtils';

const CVCompletionGauge = () => {
  const { cvData } = useCV();
  
  // Use the centralized formatting function from the utils
  const formattedCV = formatCVForCompletion(cvData);
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Typography variant="caption" color="text.secondary" sx={{ mr: 2 }}>
          Completion Rate
        </Typography>
        <Box sx={{ width: 60, height: 50, mt: -5 }}>
          <CVCompletionGaugeCard cv={formattedCV} size={70} />
        </Box>
      </Box>
    </Box>
  );
};

export default CVCompletionGauge; 